import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registered successfully:', registration);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
      })
      .catch((error) => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });

  // Listen for service worker updates
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('🔄 Service Worker updated - page will refresh');
    window.location.reload();
  });
}

// Listen for online/offline events
window.addEventListener('online', () => {
  console.log('🌐 Back online!');
  // Dispatch custom event for App to listen
  window.dispatchEvent(new Event('online'));
});

window.addEventListener('offline', () => {
  console.log('📴 Went offline!');
  // Dispatch custom event for App to listen
  window.dispatchEvent(new Event('offline'));
});
